<mat-sidenav-container>
  <mat-sidenav color="accent" mode="side" opened [ngClass]="{ opened: (opened | async), closed: !(opened | async) }">
    <div class="nav-header">
      <button (click)="navigationService.toggleSidenav()" mat-icon-button>
        <mat-icon>{{ (opened | async) ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</mat-icon>
      </button>
      @if (opened | async) {
      <h2 class="sidenav-header">My Dashboard</h2>
      }
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between start">
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'schedule', 'list']"
      >
        <mat-icon>event</mat-icon>
        @if (opened | async) {
        <span>Appointments</span>
        }
      </button>
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'patient', 'chat-dashboard']"
      >
        <mat-icon>forum</mat-icon>
        @if (opened | async) {
        <span
          matBadge="{{ unreadCount | async }}"
          matBadgeHidden="{{ !(unreadCount | async) > 0 }}"
          matBadgeColor="warn"
          matBadgeOverlap="false"
          matBadgePosition="after"
          >Chat Dashboard</span
        >
        }
      </button>
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'patients']"
      >
        <mat-icon>face</mat-icon>
        <span [hidden]="!(opened | async)">Patients</span>
      </button>
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'membership', 'list']"
      >
        <mat-icon>group</mat-icon>
        @if (opened | async) {
        <span>Memberships</span>
        }
      </button>
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'membership', 'types']"
      >
        <mat-icon>card_membership</mat-icon>
        @if (opened | async) {
        <span>Membership Types</span>
        }
      </button>
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'company']"
      >
        <mat-icon>business</mat-icon>
        @if (opened | async) {
        <span>Clients</span>
        }
      </button>

      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'markets']"
      >
        <mat-icon>store</mat-icon>
        @if (opened | async) {
        <span>Markets</span>
        }
      </button>
      @if (!isUsingIdentityService) {
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'provider', 'list']"
      >
        <mat-icon>assignment_ind</mat-icon>
        @if (opened | async) {
        <span>Users</span>
        }
      </button>
      } @else {
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        (click)="onUsersToolClicked()"
      >
        <mat-icon>assignment_ind</mat-icon>
        @if (opened | async) {
        <span>Users</span>
        }
      </button>
      }
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'billing']"
      >
        <mat-icon>description</mat-icon>
        @if (opened | async) {
        <span>Billing</span>
        }
      </button>
      <button
        mat-icon-button
        class="nav-button"
        [ngClass]="{ 'mat-icon-button': !(opened | async) }"
        routerLinkActive="active"
        [routerLink]="['/', 'dashboard', 'schedule', 'home-visit-request', 'list']"
      >
        <mat-icon>bookmark</mat-icon>
        @if (opened | async) {
        <span
          matBadge="{{ unviewedCount | async }}"
          matBadgeColor="warn"
          matBadgeHidden="{{ (unviewedCount | async) > 0 ? false : true }}"
          matBadgeOverlap="false"
          matBadgePosition="after"
          >Scheduling Requests</span
        >
        }
      </button>
    </div>
  </mat-sidenav>
  <mat-sidenav-content [ngClass]="{ 'sidenav-closed--content': !(opened | async) }">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
